import { Component, OnInit } from '@angular/core';
import { MyDatePickerModule, IMyDpOptions } from 'mydatepicker';
import { CallBackEndService } from '../call-back-end.service';
import { IbRequest } from '../ib-request';
import { IbResponse } from '../ib-response';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { Angular2CsvModule } from 'angular2-csv';
declare var getHexAscii: any;
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
import * as jsPDF from 'jspdf';
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import 'rxjs/Rx';
import {DatePipe} from "@angular/common";

@Component({
  selector: 'app-loan-statment-of-account',
  templateUrl: './loan-statment-of-account.component.html',
  styleUrls: ['./loan-statment-of-account.component.css'],
    providers: [
{ provide: 'Window', useValue: window },
      [DatePipe]
]
})
export class LoanStatmentOfAccountComponent implements OnInit {
  
   public filterQuery = '';
    public rowsOnPage = 5;
    public sortBy = 'particulars';
    public sortOrder = 'asc';
isShow: string = 'page1';
  isShow1: string = 'page1';
   scoAccounts: any;
  scoAndLoanAccounts : any =[];
  loanAccounts : any = [];
  accountDigit :any ;
  fromDate : any;
   toDate : any;
    fromDate1 : any;
  isDisabled:boolean=false;
   toDate1 : any;
  loanacct : string ="";
  address1 : string ;
  address2 : string ;
  
  totalDebit =0;//: any ;
  totalCredit =0;// : any;
  totalAmount =0;//: any;
  crOrDr : any;
  space='  ';
   isError:boolean=false;
   error:string="";
  moduleType : string ='';
  fullName : string ='' ;
  clrBalanceStr : string ='';
  
 // loanStatementOfAccountResp : any=[];
    data: any [];

  loanAcct: any;
  loanacctNo: string = '';
  loanAccountHolderDetails : any =[];
  excelOrPdfName : string ;
  showLoanAmount : string ='Hide';
  mytime:Date = new Date();
  currentYear:any= this.mytime.getUTCFullYear();
  currentDate:any= this.mytime.getUTCDate()+1;
  currentMonth:any= this.mytime.getUTCMonth() + 1;
  currentMonth1:any= this.mytime.getUTCMonth() + 7;
  fromyear=this.mytime.getUTCFullYear()-10;
  subBtnDisabled:boolean=false;
  fromDateNull : string ='';
  toDateNull : string='';
  messageForDate : string = '';
  messageForDate1 : string = '';
  messageForDate2 : string = '';
  fromGreaterCurrent : string ='';
  accountNull : string = '';
  statacct: string;
  formatedDate : string='';
  message: string;
   loanAcctInfo() {
    const request: IbRequest = new IbRequest();
    let response: IbResponse = null;
    request.param1 = getHexAscii('', this.loanacctNo);
    request.param2 = this.loanacctNo;
    this.webService.getResponse(request, 'miniTransactionList').subscribe((data: IbResponse) => {
      if (data !== null && data.status === 'S200') {
        //this.transactionListRespTD=IbResponse;
        this.loanAcct = data.param5;
        this.moduleType = data.param5.moduleType;
        this.fullName = data.param5.fullName;
        this.clrBalanceStr = data.param5.clrBalanceStr;
        this.isShow = 'page2';
        this.showLoanAmount ='Hide';
      } else if (data !== null && data.status === 'S200') {
        //this.error = response.statusDescription;
      }else{
        console.log(data.status);
      }
    });
  }
  
  constructor(private webService: CallBackEndService,
    private spinnerService: Ng4LoadingSpinnerService,
              private datePipe: DatePipe
  
  ) {
  this.scoAccounts = JSON.parse(sessionStorage.getItem('scoAccounts'));
    this.scoAndLoanAccounts = JSON.parse(sessionStorage.getItem('scoAndLoanAccounts'));
    this.loanAccounts = JSON.parse(sessionStorage.getItem('loanAccounts'));
    console.log("loan account isss "+this.loanAccounts+"sc accounts iss "+this.scoAndLoanAccounts);
    
    
     this.loanAccounts = JSON.parse(sessionStorage.getItem('loanAccounts'));
    
     
    
    
    
    const request: IbRequest = new IbRequest();
    let response: IbResponse = null;
    this.loanacctNo=this.loanAccounts[0];
    request.param1 = getHexAscii('', this.loanacctNo);
    request.param2 = this.loanacctNo;
    if(this.loanacctNo === undefined ){
      this.isShow='RecordNotFound';
      this.message="Record Not Found";
    }
    else {
      this.webService.getResponse(request, 'miniTransactionList').subscribe((data: IbResponse) => {
        if (data !== null && data.status === 'S200') {
          //this.transactionListRespTD=IbResponse;
          this.loanAcct = data.param5;
          this.moduleType = data.param5.moduleType;
          this.fullName = data.param5.fullName;
          this.clrBalanceStr = data.param5.clrBalanceStr;
          this.isShow = 'page2';
          // this.showLoanAmount ='Hide';
        } else if (data !== null && data.status === 'S200') {
          //this.error = response.statusDescription;
        } else {
         // alert(data);
        }
      });
    }
    
   }
   loanAccount1 = JSON.parse(sessionStorage.getItem('loanAccounts'));
   
  scoAndLoanAccount1 = JSON.parse(sessionStorage.getItem('scoAndLoanAccounts'));
  ngOnInit() {
    this.formatedDate = this.datePipe.transform(new Date(), 'dd-MMM-yyyy');
   
  }
  myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'dd-mm-yyyy',
    editableDateField:false,
	//disableUntil:{year: this.fromyear, month: this.currentMonth, day: this.currentDate-2},
	disableUntil:{year: this.fromyear, month: this.currentMonth, day: this.currentDate-2},
     disableSince:{year: this.currentYear, month: this.currentMonth, day: this.currentDate},
  };
  myDatePickerOptions1: IMyDpOptions = {
    dateFormat: 'dd-mm-yyyy',
    editableDateField:false,
   // disableSince:{year: this.currentYear, month: this.currentMonth, day: this.currentDate},
   disableUntil:{year: this.fromyear, month: this.currentMonth, day: this.currentDate-2},
     disableSince:{year: this.currentYear, month: this.currentMonth, day: this.currentDate},
  };
  dateconvert(monthNumber) { //1 = January
    var monthNames = [ 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'June',
      'July', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec' ];
    return monthNames[monthNumber - 1];
  }
loanStatment() {

  this.isDisabled = true;
  const request: IbRequest = new IbRequest();
  let response: IbResponse = null;
  this.spinnerService.show();
  //this.isLoad = true;
  this.subBtnDisabled = true;
  this.accountNull = '';
  this.fromDateNull = '';
  this.toDateNull = '';
  //this.isLoad = true;
  if (this.loanacct === '' || this.loanacct === undefined || this.loanacct === null) {
    this.accountNull = 'no';
    this.spinnerService.hide();
    this.subBtnDisabled = false;
  } else if (this.fromDate === '' || this.fromDate === undefined || this.fromDate === null) {
    this.fromDateNull = 'no';
    this.subBtnDisabled = false;
    this.spinnerService.hide();
  } else if (this.toDate === '' || this.toDate === undefined || this.toDate === null) {
    this.toDateNull = 'no';
    this.subBtnDisabled = false;
    this.spinnerService.hide();
  } else {

    this.messageForDate = '';
    this.messageForDate1 = '';
    this.messageForDate2 = '';
    this.fromGreaterCurrent = '';
    var date1 = (this.fromDate.date.day + "-" + this.dateconvert(this.fromDate.date.month) + "-" + this.fromDate.date.year).split("-");
    var date2 = (this.toDate.date.day + "-" + this.dateconvert(this.toDate.date.month) + "-" + this.toDate.date.year).split("-");
    var date3 = this.formatedDate.split("-");
    console.log('all date : '+date1+date2+date3);
    var d1 = Date.parse(date1[0] + "-" + date1[1] + "-" + date1[2]);
    var d2 = Date.parse(date2[0] + "-" + date2[1] + "-" + date2[2]);
    var d3 = Date.parse(date3[0] + "-" + date3[1] + "-" + date3[2]);
    if (d1 > d2) {
      this.messageForDate = 'no';
      this.subBtnDisabled = false;
      this.spinnerService.hide();
    }
    else if (d2 > d3) {
      this.messageForDate1 = 'no';
      this.subBtnDisabled = false;
      this.spinnerService.hide();
    } 
    else if (d1 > d3) {
      this.fromGreaterCurrent = 'no';
      this.subBtnDisabled = false;
      this.spinnerService.hide();
    } else {
      this.accountDigit = this.scoAccounts[0];
      console.log("sco account iss " + this.accountDigit);

      //const frm =JSON.stringify(this.fromDate1);
      console.log("frm date " + this.fromDate.formatted + "");
      console.log("frm year " + this.fromDate.date.year + "");
      console.log("frm month " + this.fromDate.date.month + "");
      console.log("frm day " + this.fromDate.date.day + "");
      request.param3 = this.fromDate.date.day + "-" + this.getMonthName(this.fromDate.date.month) + "-" + this.fromDate.date.year;
      request.param4 = this.toDate.date.day + "-" + this.getMonthName(this.toDate.date.month) + "-" + this.toDate.date.year;
      
      request.param5 =sessionStorage.getItem('storedUserName');
      request.param1 = getHexAscii('', this.loanacct + request.param3 + request.param4+request.param5);
      //request.param2=sessionStorage.getItem('storedUserName');
      //request.param2 = this.accountDigit;
      request.param2 = this.loanacct;

      console.log("from date  " + this.fromDate + "to date  " + this.fromDate);
      this.webService.getResponse(request, 'loanAccountStatement').subscribe((data: IbResponse) => {       
        this.spinnerService.hide();
        this.subBtnDisabled = false;
        if(data.status!='S200'){
           this.isError=true;
           this.error=data.param1;
           this.isShow1 = '';
           return;
        }
        this.isDisabled = false;
        this.loanAccountHolderDetails = data.param5;
        this.data = data.param6;
        
        console.log('length ---' + this.data.length);
        if (data !== null && data.status === 'OBJECT_NOT_FOUND' ) {
          console.log('loop1');

          // this.isError=true;
          this.error = data.statusDescription;
          this.isError = true;
          this.subBtnDisabled=false;
        //  this.spinnerService.hide();
        } else if( this.data==null || this.data==undefined || this.data.length==0){
          console.log('param 6 is null');
          this.error = 'Record Not Found';//param 6 is null
          this.isError = true;
          this.isShow1 = '';
          this.subBtnDisabled=false;
        } else {
          this.excelOrPdfName = this.loanAccountHolderDetails.accountNo15Digit + '_' + this.loanAccountHolderDetails.todayDate;
          if( this.loanAccountHolderDetails.add1!=null && this.loanAccountHolderDetails.add1!=undefined && this.loanAccountHolderDetails.add1!==''){
            this.address1 = this.loanAccountHolderDetails.add1 + ', ';
          }
          if( this.loanAccountHolderDetails.add2!=null && this.loanAccountHolderDetails.add2!=undefined && this.loanAccountHolderDetails.add2!==''){
            this.address1 =  this.address1 +this.loanAccountHolderDetails.add2 + ', ';
          }
          if( this.loanAccountHolderDetails.add3!=null && this.loanAccountHolderDetails.add3!=undefined && this.loanAccountHolderDetails.add3!==''){
            this.address1 = this.address1 + this.loanAccountHolderDetails.add3 + ', ';
          }
         // this.address1 = this.loanAccountHolderDetails.add1 + ',' + this.loanAccountHolderDetails.add2 + ',' + this.loanAccountHolderDetails.add3;
          this.address2 = this.loanAccountHolderDetails.areaDesc + ','  + this.loanAccountHolderDetails.cityDesc
            + ',' + this.loanAccountHolderDetails.pinCd;
          
            this.isError = false;
            this.error='';
          this.isShow1 = 'page2';
          for (const [key, value] of Object.entries(this.data)) {
            if (value.drCr === 'D') {
              this.totalDebit = this.totalDebit + Number(value.fcyTrnAmt || 0);
              this.crOrDr = 'DR';
            }
            if (value.drCr === 'C') {
              this.totalCredit = this.totalCredit + Number(value.fcyTrnAmt || 0);
              this.crOrDr = 'CR';
            }
            this.totalAmount = value.balance;

          }
          if (data !== null && data.status === 'S200') {
            this.isShow1 = 'page2';
            this.isDisabled = false;
            this.spinnerService.hide();
           // this.subBtnDisabled = true;

          } else if (data.status === 'S101') {
            this.spinnerService.hide();
            alert('Malicious Request Detected');
            //this.isLoad = false;


          }
        }
      });
    }
  }
}
  
   
  
  
  // Final Code for Download CSV Function
 
 downloadPdf() {
 
var pdf = new jsPDF();
        var a = Number(20 || 0);
        var b = Number(5 || 0); 
        var c = Number(30 || 0);
        var d = Number(20 || 0);
        var e = Number(179 || 0);
        var f = Number(24 || 0);
        var g = Number(3 || 0);
        var h = Number(2 || 0); 
        var i = Number(1 || 0);
        // this.totalDebit = Number(0 || 0);
        //   this.totalCredit = Number(0 || 0);
        //   this.totalAmount = Number(0 || 0);
         // this.crOrDr='';
   pdf.setFontSize(6);
   
    pdf.text(h+2, a, ''); pdf.text(h+108, a, '');a=a+b; d=d+b; //blank line
    pdf.text(h+2, a, ''); pdf.text(h+108, a, '');a=a+b; d=d+b;

    pdf.text(h+2, a, 'Loan Account No : ');pdf.text(25,a,this.loanAccountHolderDetails.accountNo15Digit); pdf.text(h+108, a, 'Branch IFSC Code : '+this.loanAccountHolderDetails.branchIfscCd);a=a+b; d=d+b;
    pdf.text(h+2, a, 'Name Of Borrower : ');pdf.text(25,a,''+this.loanAccountHolderDetails.name); pdf.text(h+108, a, 'Branch MICR Code : '+this.loanAccountHolderDetails.micrCode); a=a+b; d=d+b;
    pdf.text(h+2, a, 'Address : '); pdf.text(25, a, this.address1); a=a+g; d=d+g;
                       pdf.text(25, a, this.address2); a=a+b; d=d+b;
    pdf.text(h+2, a, 'Contact Number : '); pdf.text(25, a, this.loanAccountHolderDetails.phoneNo); a=a+g; d=d+g;                   
    pdf.text(h+2, a, 'Joint Names 1 : ');pdf.text(25,a,this.loanAccountHolderDetails.firstJointHolder); pdf.text(h+108, a, 'Joint Names 2 : '+this.loanAccountHolderDetails.secondeJointHolder);a=a+b; d=d+b;                 
    pdf.text(h+2, a, 'No Of Instalment  : ');pdf.text(25,a,this.loanAccountHolderDetails.noOfInstallment);pdf.text(h+108, a, 'Date Of Sanction : '+this.loanAccountHolderDetails.dateOfSanction);a=a+b; d=d+b;
    pdf.text(h+2, a, 'Loan Amount : ');pdf.text(25,a,this.loanAccountHolderDetails.tempTotOverDue);pdf.text(h+108, a, 'Interest Rate : '+this.loanAccountHolderDetails.intrest);a=a+b; d=d+b;
    pdf.text(h+2, a, 'Monthly Installment Payable (Inst + Int) : '+this.loanAccountHolderDetails.monthlyInsAmt);pdf.text(h+108, a, 'Drawing Power : '+this.loanAccountHolderDetails.tempDp);a=a+b; d=d+b;
    pdf.text(h+2, a, 'Expiry Date : ');pdf.text(25,a,this.loanAccountHolderDetails.limitExpDate);pdf.text(h+108, a, 'Expiry Date with Grace Period : '+this.loanAccountHolderDetails.expDateGrace);a=a+b; d=d+b;
    pdf.text(h+2, a, 'Period : ');pdf.text(25,a,this.loanAccountHolderDetails.period);a=a+b; d=d+b;
    c=d+5;
    pdf.line(2, a-3, e, a-3);
        for(const [key, value] of Object.entries(this.data)) {    
          let srNo : number = +key;   //(srNo+1).toString()       
            if(i===1){
            pdf.setFontType("bolditalic");
            pdf.setTextColor(0, 0, 255);
              
            pdf.text(h, a, 'SR. No.');
            pdf.text(h+8, a, 'Date');
            pdf.text(h+38, a, 'Particulars');
            pdf.text(110, a, 'Instruments');
            pdf.text(h+123, a, 'Dr Amount');
            pdf.text(h+138, a, 'Cr Amount');
            pdf.text(h+153, a, 'Total Amount');
            pdf.text(h+170, a, 'DR/CR');

            pdf.setTextColor(100);
            }
            i++;
            // a=a+b;
            // c=c+5;
            // pdf.line(2, a-3, e, a-3);       
            a = a + b+4;
            c = c + 5+4;
            pdf.line(2, a - 7, e, a - 7);

        if((i-1)%f===0){
            pdf.setFontType("bolditalic");
            pdf.setTextColor(0, 0, 255);
              
            pdf.text(h, a, 'SR. No.');
            pdf.text(h+8, a, 'Date');
            pdf.text(h+38, a, 'Particulars');
            pdf.text(110, a, 'Instruments');
            pdf.text(h+123, a, 'Dr Amount');
            pdf.text(h+138, a, 'Cr Amount');
            pdf.text(h+153, a, 'Total Amount');
            pdf.text(h+170, a, 'DR/CR');

            pdf.setTextColor(100);
            // a=a+b;
            // c=c+5;
            // i++;
            // pdf.line(2, a-3, e, a-3); 
            a = a + b+4;
            c = c + 5+4;
            i++;
            pdf.line(2, a - 7, e, a - 7);
            
            pdf.text(h+3, a, (srNo+1).toString());
            pdf.text(h+8, a, value.postDate+'');
            // pdf.text(h+38, a, value.particulars+'');
            if(value.particulars.length>52){
              //this.hasExtraLine=true;
              pdf.text(40, a-3, value.particulars.substring(0,52));
              pdf.text(40, a+1, value.particulars.substring(52,104));
            }else{
              pdf.text(40, a, value.particulars);
            }
            pdf.text(110, a, value.instrNo);

        if(value.drCr==='D'){
          pdf.text(h+123, a, value.fcyTrnAmt+'');
          pdf.text(h+170, a, 'DR');
          /*totalDrAmount=totalDrAmount+Number(value.fcyTrnAmt || 0);
          crDr='DR';*/
        }
        if(value.drCr==='C'){
          pdf.text(h+138, a, value.fcyTrnAmt+'');
          pdf.text(h+170, a, 'CR');
          /*totalCrAmount=totalCrAmount+Number(value.fcyTrnAmt || 0);
          crDr='CR';*/
        }
            pdf.text(h+153, a, value.balance+'');
            
        }else{
                pdf.text(h+3, a, (srNo+1).toString());
            pdf.text(h+8, a, value.postDate+'');
            // pdf.text(h+38, a, value.particulars+'');
            if(value.particulars.length>52){
              //this.hasExtraLine=true;
              pdf.text(40, a-3, value.particulars.substring(0,52));
              pdf.text(40, a+1, value.particulars.substring(52,104));
            }else{
              pdf.text(40, a, value.particulars);
            }
            pdf.text(110, a, value.instrNo);

        if(value.drCr==='D'){
          pdf.text(h+123, a, value.fcyTrnAmt+'');
          pdf.text(h+170, a, 'DR');
          /*totalDrAmount=totalDrAmount+Number(value.fcyTrnAmt || 0);
          crDr='DR';*/
        }
        if(value.drCr==='C'){
          pdf.text(h+123, a, value.fcyTrnAmt+'');
          pdf.text(h+170, a, 'CR');
          /*totalCrAmount=totalCrAmount+Number(value.fcyTrnAmt || 0);
          crDr='CR';*/
        }
            pdf.text(h+153, a, value.balance+'');
        }
        //totalClosingAmount = value.balance;
        if(i%f===0){
          pdf.line(h, d-3, h, c-3);
          pdf.line(h+7, d-3, h+7, c-3);
          pdf.line(h+37, d-3, h+37, c-3);
          pdf.line(109, d - 3, 109, c - 3);
          pdf.line(h+122, d-3, h+122, c-3);
          pdf.line(h+137, d-3, h+137, c-3);
          pdf.line(h+152, d-3, h+152, c-3);
          pdf.line(h+167, d-3, h+167, c-3);
          pdf.line(h+177, d-3, h+177, c-3);
          
          pdf.line(h, a+2, e, a+2);
          
          pdf.addPage();
          a=20;
          d=25;
          c=25;
        }
        }
    
    pdf.line(h, d-3, 2, c-3);
    pdf.line(h+7, d-3, h+7, c-3);
    pdf.line(h+37, d-3, h+37, c-3);
    pdf.line(109, d - 3, 109, c - 3);
    pdf.line(h+122, d-3, h+122, c-3);
    pdf.line(h+137, d-3, h+137, c-3);
    pdf.line(h+152, d-3, h+152, c-3);
    pdf.line(h+167, d-3, h+167, c-3);
    pdf.line(h+177, d-3, h+177, c-3);
    
    pdf.line(h, a-3, e, a-3); 
    
    a=a+b;
    pdf.text(h, a, 'Totals / Balance :-');
    pdf.text(h+123, a, this.totalDebit.toFixed()+'');
    pdf.text(h+138, a, this.totalCredit.toFixed()+'');
    pdf.text(h+153, a, this.totalAmount+'');
    pdf.text(h+168, a, this.crOrDr);
    
    pdf.line(2, a-3, e, a-3); 
    
    a=a+b;
    pdf.text(h, a, 'Closing Balance :-');
    pdf.text(h+153, a, this.totalAmount+'');
    pdf.line(h, a-3, e, a-3); 
    
    a=a+b;
    pdf.line(h, a-3, e, a-3); 

 var img = new Image;
    img.onload = function() {
      pdf.setPage(1);
        pdf.addImage(this, 2, 5, 100, 17);
        pdf.save("LoanStatment"+".pdf");
    };
    img.crossOrigin = "";
    img.src = 'assets/img/LogoWithName.png';

}
  
   downloadcsv(){
    var csvData = this.ConvertToCSV(this.data);
    var a = document.createElement("a");
    a.setAttribute('style', 'display:none;');
    document.body.appendChild(a);
    var blob = new Blob([csvData], { type: 'text/csv' });
    var url= window.URL.createObjectURL(blob);
    a.href = url;
    a.download = 'LoanStatment.csv';
    a.click();
}
  ConvertToCSV(objArray) {
            var array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray;
            var str = '';
            var row = "";
 
            for (var index in objArray[0]) {
                //Now convert each value to string and comma-separated
                row += index + ',';
            }
            row = row.slice(0, -1);
            //append Label row with line break
            str += row + '\r\n';
 
            for (var i = 0; i < array.length; i++) {
                var line = '';
                for (var index in array[i]) {
                    if (line !== ''){ line += ',';}
 
                    line += array[i][index];
                }
                str += line + '\r\n';
            }
            return str;
        }
  
 // setData(year, month, day) {
   // let date = moment().set({'year': year, 'month': month, 'day': day});
    //return date.format('L')  // 01/24/2018
//}
getMonthName(month) { 
return ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep", "Oct","Nov","Dec"][Number(month)-1];
}
  removestacctMessage()
  {
    this.accountNull='';
  }
}





// WEBPACK FOOTER //
// D:/Sonali/JCCBViewOnlyProject/ViewOnlyJCCBfrontend19112022/InternetBanking6.3frontend/src/app/loan-statment-of-account/loan-statment-of-account.component.ts